
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/subscription",
      function () {
        return require("private-next-pages/subscription/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/subscription"])
      });
    }
  